import { inject, Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ToastrService } from 'src/app/shared/services/toastr/toastr-service';
import { LangService } from 'src/app/shared/services/lang/lang.service';
import { ApiService } from 'src/app/shared/services/api/api.service';
import {
  createCryptotokenDataEffects,
  createCryptotokenDeleteEffects,
  CryptotokenDataActions,
} from './cryptotoken-data.feature';
import { extractErrorMessage } from 'src/app/shared/util/extract-error-message';

@Injectable()
export class CryptotokenDataEffects {
  private action$ = inject(Actions);
  private store = inject(Store);
  private apiService = inject(ApiService);
  private toastrService = inject(ToastrService);
  private langService = inject(LangService);
  private labels = this.langService.lang.features.cryptotokenData;

  private effects = createCryptotokenDataEffects(this.action$, this.store, {
    load: () => this.apiService.getCryptotokenList(),
    notifyError: () =>
      this.toastrService.error(this.labels.toasts.fetchingError),
  });

  fail$ = this.effects.fail$;
  load$ = this.effects.load$;
  ensure$ = this.effects.ensure$;

  private deleteEffects = createCryptotokenDeleteEffects(this.action$, {
    deleteItem: token =>
      this.apiService.deleteCryptotoken(token.tokenName ?? ''),
    notifyError: (token, error) =>
      this.toastrService.error(
        extractErrorMessage(error) ||
          this.labels.toasts.defaultDeletionError(token),
      ),
    notifySuccess: token =>
      this.toastrService.success(this.labels.toasts.deletionSuccess(token)),
    onSuccess: deletedToken =>
      this.store.dispatch(
        CryptotokenDataActions.transform({
          transformation: tokens =>
            tokens.filter(token => token.tokenName !== deletedToken.tokenName),
        }),
      ),
  });

  delete$ = this.deleteEffects.delete$;
  deleteFail$ = this.deleteEffects.deleteFail$;
  deleteSuccess$ = this.deleteEffects.deleteSuccess$;
}
